module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl1_en.aec5f2626a4a83c2c1ad654cb43f248f.png";